var $ = require('jquery');

var $header = $('#header');
// Nav Fixed
$(window).on('scroll', function() {
    if ($(window).scrollTop() > 300) {
        $header.addClass('is-fixed');
    } else {
        $header.removeClass('is-fixed');
    }
});

// Nav Toggle Button
$('#toggle').on('click', function(){
    $('body').toggleClass('is-open');
});

$('.wrapper__innerNavbg').on('click', function(){
    $('body').toggleClass('is-open');
});